<template>
  <div class="feedbacks-page pa-6">
    <p-container>
      <!-- Title -->
      <h2 class="mb-4">
        <p-button tertiary @click="$router.back()">
          <p-icon>keyboard_backspace</p-icon>
        </p-button>
        {{ $t('page.dashboard.organisations.feedbacks.title') }}
      </h2>
      <p-row>
        <!-- Search Field -->
        <p-col xs12 md6 lg3>
          <p-text-field v-model="page.organisationFeedbacks.filter.searchCriteria" clearable :label="$t('core.app.search')" context-icon="search"></p-text-field>
        </p-col>
        <!-- Event Filter -->
        <p-col xs12 md6 lg3>
          <p-select
            v-model="page.eventsDataSource.filter.eventIdentifier"
            :label="$t('page.events.select.eventName')"
            :items="page.eventItems"
            @input="page.refreshFeedbacks()"
          ></p-select>
        </p-col>
      </p-row>
      <p-list-view
        v-model="page.organisationFeedbacksList"
        :pagination.sync="page.organisationFeedbacks.paging"
        :columns="page.feedbackColumns"
      >
        <template slot="table-actions">
          <!-- Refresh Button -->
          <p-button :disabled="isLoading" @click="page.refreshFeedbacks()">
            <p-icon>refresh</p-icon>
          </p-button>
          <!-- Excel ausdruck Button -->
          <div v-if="page.organisationFeedbacks.data">
            <p-button v-if="page.organisationFeedbacks.data.items.length > 0" :disabled="isLoading" :loading="page.isLoadingExcel" @click="page.downloadExcel()">
              {{ $t('page.dashboard.organisations.feedbacks.button.excelDownload') }}
            </p-button>
          </div>
        </template>
      </p-list-view>
    </p-container>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import FeedbacksPage from './feedbacks.vue.model';

  export default Vue.extend({
    name: 'Feedbacks',
    data: () => ({
      page: new FeedbacksPage(),
      isLoading: false,
    }),
    async beforeMount() {
      if (await this.$service.v2.api.tdg_Users.amIOrganisation()) {
        this.isLoading = true;
        this.page.initialize();
        this.isLoading = false;
      } else if (await this.$service.v2.api.tdg_Users.amICompany()) {
        this.$router.push('/tourdegwaerb/company/dashboard');
      } else {
        this.$router.push('/TourDeGwaerb/IL/');
      }
    },
    mounted() {
    },
    methods: {

    },
  });
</script>
